import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { filter, takeUntil } from 'rxjs/operators';

import { AssessmentLevelsService } from 'app/assessment/assessment-levels.service';
import { AssessmentInfoViewModel } from 'app/assessment/AssessmentInfoViewModel';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { getSafe, isNilOrEmpty } from 'helpers';

import { SearchActivityEvents } from 'generated/graphql';

@Component({
  selector: 'app-assessment-event',
  templateUrl: './assessment-event.component.html'
})

export class ASAssessmentEventComponent extends WithDisposableSubject() implements OnInit {

  @Input() item: SearchActivityEvents.Node;

  _assessmentInfoViewModels: AssessmentInfoViewModel[] = [];
  /**
   *
   */
  constructor(
    private _assessmentLevelsService: AssessmentLevelsService,
    private cd: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this._assessmentLevelsService.getAssessmentInfoViewModelsForEntityType()
      .pipe(
        takeUntil(this.disposer),
        filter(vi => !isNilOrEmpty(vi))
      ).subscribe((ais) => {
        this._assessmentInfoViewModels = ais;
        this.cd.markForCheck();
      });
  }

  getColorClass(level: number) {
    const color = getSafe(
      () => this._assessmentInfoViewModels.find(aiv => aiv.level === level).color,
      null
    );
    return `a${color}`;
  }

  getIconClass(beforeLevel: number, afterLevel: number) {
    return (beforeLevel < afterLevel) ? 'fa-chart-line' : 'fa-chart-line-down';
  }

}
